import themes from "daisyui/src/theming/themes";
import { ConfigProps } from "./types/config";
const config = {
  // REQUIRED
  appName: "PFPMaker - AI Profile Picture Studio",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appDescription:
    "Generate professional LinkedIn or creative profile pictures in seconds. 27+ AI tools, 1,100+ styles. Start with 9 free tools, upgrade anytime",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "ai.pfpmaker.com",
  mailerlite: {
    // MailerLite group IDs for automatic subscriber management
    // Note: Groups must be created manually in MailerLite dashboard first
    groups: {
      payingCustomers: '170160754314446699',
      subscribers: '170161195002627732',
      creditBuyers: '170161203668059704',
    },
  },
  stripe: {
    // Billing portal configuration ID from Stripe Dashboard
    // Using NEXT_PUBLIC_ prefix so client components can read it at runtime
    portalConfigurationId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "bpc_1SAerCDbp0tkdiCQLoBD56Dl" : "bpc_1SGmRyDGMkkcbn47Paa0i14p",
    // Subscription plans
    plans: [
      {
        priceId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "price_1SBDaODbp0tkdiCQvxtl876A" : "price_1SGma2DGMkkcbn47X4TfvJIq",
        yearlyPriceId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "price_personal_yearly_dev" : "zzzzzzzzzzzzzzzzzzzzzz",
        name: "Starter",
        description: "Create Your Perfect Look",
        price: 9,
        yearlyPrice: 6,
        mode: "subscription",
        includedCredits: 180,
        features: [
          { name: "180 credits monthly" },
          { name: "All 60+ AI tools (1,172+ styles)" },
          { name: "Credits rollover (never expire within 3 months)" },
        ],
        targetAudience: "Perfect for: Social media, gaming, work, dating - any profile"
      },
      {
        priceId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "price_1SGO6mDbp0tkdiCQFtwJwo9R" : "price_1SGmbADGMkkcbn47vvDKSOYg",
        yearlyPriceId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "price_standard_yearly_dev" : "zzzzzzzzzzzzzzzzzzzzzz",
        isFeatured: true,
        name: "Pro",
        description: "Level Up Your Look",
        price: 15,
        priceAnchor: 23,
        yearlyPrice: 10,
        mode: "subscription",
        includedCredits: 360,
        couponId: "3c0wyl4n", // $4.01 off (35% display) forever - Black Friday/Cyber Monday 2024
        features: [
          { name: "360 credits monthly" },
          { name: "Asset Manager (save uploads and favorites)" },
          { name: "All 60+ AI tools (1,172+ styles)" },
          { name: "Credits rollover (never expire within 3 months)" },
          { name: "Best value per image" },
        ],
        targetAudience: "Perfect for: Creators, streamers, active users across all platforms"
      },
      {
        priceId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "price_1SGO9nDbp0tkdiCQ4J9vCvOR" : "price_1TK7sXDGMkkcbn477FoBpS9r",
        yearlyPriceId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "price_premium_earlybird_yearly_dev" : "zzzzzzzzzzzzzzzzzzzzzz",
        isMostPowerful: true,
        name: "Premium",
        description: "Unlimited Creative Power",
        price: 20,
        priceAnchor: 49,
        yearlyPrice: 17,
        mode: "subscription",
        includedCredits: 1050,
        earlyBirdPrice: 20,
        futurePrice: 35,
        badge: "Early Bird",
        features: [
          { name: "1,050 credits monthly" },
          { name: "Asset Manager (save uploads and favorites)" },
          { name: "Priority support" },
          { name: "Batch processing", badge: "Coming Soon" },
          { name: "All 60+ AI tools (1,172+ styles)" },
          { name: "Credits rollover (never expire within 3 months)" },
        ],
        targetAudience: "Perfect for: Power users, teams, agencies, content at scale"
      },
    ],
    // Credit top-ups (quantity-based purchasing)
    creditTopups: {
    priceId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "price_1SGORYDbp0tkdiCQKzS1gWkm" : "price_1SGmUBDGMkkcbn47eBteFaxI",
    // 0.25/3 keeps pack $ prices stable while granting 3x credits (qty = credits at checkout)
    baseRate: 0.08333333333333333,
    packages: [
      { credits: 150, discount: 4, couponId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "VtPnLN4Q" : "wAgWbime" },
      { credits: 300, discount: 12, couponId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "Tc2hJWKm" : "6eAPfIIZ", promoCouponId: "EjfeOHKJ", promoDiscount: 36 },
      { credits: 600, discount: 20, couponId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "NYAfZqLc" : "XGeZNf0z" },
      { credits: 900, discount: 25, couponId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "YbmyafTq" : "bOxLsj6T" },
      { credits: 1500, discount: 30, couponId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "6DDLBPiH" : "zohuDmyO" },
      { credits: 3000, discount: 36, couponId: process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true" ? "tZellZDU" : "EjfeOHKJ" },
    ],
    },
    // Face AI full report ($9). Stubs — replace with real Stripe Price IDs.
    faceAiFullReport: {
      productKey: "face_ai_full_report",
      priceId:
        process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true"
          ? process.env.STRIPE_FACE_AI_PRICE_ID_DEV ||
            "price_1U0WCoDbp0tkdiCQO3jBRISA"
          : process.env.STRIPE_FACE_AI_PRICE_ID ||
            "price_1U0TpxDGMkkcbn47w5v8qaqw",
      amountCents: 900,
      currency: "usd",
    },
    // Face AI full report ($14.99) — price_14_99 arm of face_ai_price_v1.
    // Same Stripe product, different Price object. Optional: if the priceId
    // is unset or still a stub, the server falls back to the $9 control price.
    faceAiFullReport1499: {
      priceId:
        process.env.NEXT_PUBLIC_USE_STRIPE_DEV === "true"
          ? process.env.STRIPE_FACE_AI_PRICE_ID_1499_DEV || ""
          : process.env.STRIPE_FACE_AI_PRICE_ID_1499 || "",
      amountCents: 1499,
      currency: "usd",
    },
  },
  aws: {
    // DigitalOcean Spaces (S3-compatible) configuration
    endpoint: process.env.S3_ENDPOINT || 'sfo3.digitaloceanspaces.com',
    region: process.env.S3_REGION || 'sfo3',
    bucket: process.env.S3_BUCKET || 'pfpmakerai-v3-data',
    signedUrlExpiry: 3600, // 1 hour in seconds
  },
  version: {
    api: '2.0', // API version for client compatibility checking
  },
  resend: {
    // REQUIRED — Email 'From' field to be used when sending magic login links
    fromNoReply: `PFPMaker<noreply@pfpmaker.com>`,
    // REQUIRED — Email 'From' field to be used when sending other emails, like abandoned carts, updates etc..
    fromAdmin: `Eugene at PFPMaker <hi@pfpmaker.com>`,
    // Email shown to customer if they need support.
    supportEmail: "support@pfpmaker.com",
    // When someone replies to supportEmail sent by the app, forward it to the email below (otherwise it's lost). If you set supportEmail to empty, this will be ignored.
    forwardRepliesTo: "hi@pfpmaker.com",
  },
  // Legacy Mailgun config - keeping for backward compatibility
  mailgun: {
    domain: "mg.pfpmaker.com",
    subdomain: "mg",
    fromNoReply: `PFPMakerAI <noreply@mg.pfpmaker.com>`,
    fromAdmin: `Eugene at PFPMakerAI <hi@mg.pfpmaker.com>`,
    supportEmail: "support@pfpmaker.com",
    forwardRepliesTo: "hi@pfpmaker.com",
  },
  colors: {
    // REQUIRED — The DaisyUI theme to use (added to the main layout.js). Leave blank for default (light & dark mode). If you any other theme than light/dark, you need to add it in config.tailwind.js in daisyui.themes.
    theme: "light",
    // REQUIRED — This color will be reflected on the whole app outside of the document (loading bar, Chrome tabs, etc..). By default it takes the primary color from your DaisyUI theme (make sure to update your the theme name after "data-theme=")
    // OR you can just do this to use a custom color: main: "#f37055". HEX only.
    main: themes["light"]["primary"],
  },
  auth: {
    // REQUIRED — the path to log in users. It's use to protect private routes (like /dashboard). It's used in apiClient (/libs/api.js) upon 401 errors from our API
    loginUrl: "/api/auth/signin",
    // REQUIRED — the path you want to redirect users after successfull login (i.e. /dashboard, /private). This is normally a private page for users to manage their accounts. It's used in apiClient (/libs/api.js) upon 401 errors from our API & in ButtonSignin.js
    callbackUrl: "/dashboard",
  },
  payments: {
    // REQUIRED — the path to redirect users after successful/failed payment
    successUrl: "/dashboard?payment_success=true",
    cancelUrl: "/dashboard?payment_success=false",
  },
  credits: {
    initialCredits: 0,
  },
  promo: {
    enabled: false, // Black Friday/Cyber Monday promotion DISABLED
    name: "Black Friday/Cyber Monday",
    emoji: "🎉",
    secondaryEmoji: "💝",
    colors: {
      gradient: "from-pink-500 via-fuchsia-500 to-cyan-400",
      gradientMobile: "from-pink-500 via-fuchsia-500 to-cyan-400",
      badge: "from-pink-500 to-cyan-400",
      button: "fuchsia-600",
      buttonHover: "fuchsia-50",
    },
    banner: {
      desktopText: "BLACK FRIDAY / CYBER MONDAY SALE",
      mobileTextBold: "CYBER SALE",
      mobileText: "Limited Time!",
      ctaText: "Get 36% OFF",
      mobileCtaText: "Get 36% OFF",
      subtitle: "Lock in your savings forever",
    },
    discount: {
      planName: "Standard", // Which plan gets the discount
      fixedAmount: 4.01, // $4.01 OFF (what Stripe uses) - Final price $10.99
      displayPercent: 27, // Display as 35% OFF for marketing
    },
  },
} as ConfigProps;

export default config;
